import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ItemList from "./Shop_Page/layouts/ItemList/ItemList";
import ItemDetails from "./Shop_Page/components/ItemDetails/ItemDetails";
import CategoryDisplay from "./Shop_Page/components/ProductDisplay/ProductDisplay";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ItemList />}>
            <Route path=":category" element={<CategoryDisplay />} />
            <Route path=":category/:id" element={<ItemDetails />} />
          </Route>
          <Route
            path="*"
            element={
              <div
                style={{
                  fontSize: "72px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "100vh",
                }}
              >
                Page Not Found
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
